import { CountryIso3Code } from '@domgen/dgx-fe-i18n';

export interface CustomerAddressDetails {
  line1: string;
  line2?: string;
  city?: string;
  state: string;
  country: CountryIso3Code;
  postalCode: string;
  isFormatted?: boolean;
}
